import { dispatchCustomEvent } from "../../../../javascript/shared/helpers"

export default class extends Controller {
  static targets = ["event", "task", "milestone", "dayReview"]

  connect() {
    this.initializeEventListeners()
    this.initializeDragHandler()
    this.initializeState()
    this.initializeChangeObserver()
  }

  initializeEventListeners() {
    App.Helpers.listenToCustomEvent(document, "my-via:new-activity-added", this.appendNewActivity.bind(this))
    App.Helpers.listenToCustomEvent(document, "my-via:updated-activity", this.replaceActivity.bind(this))
    App.Helpers.listenToCustomEvent(document, "my-via:remove-activity", this.removeActivity.bind(this))
    App.Helpers.listenToCustomEvent(document, "schedulables:delete-success", this.removeSchedulableMaybe.bind(this))
  }

  initializeDragHandler() {
    this.dragHandler = App.DragHandler.init([this.element], {
      moves: (el, container, handle) => el.dataset.type != "event",
      revertOnSpill: true,
      dragEndHandler: this.postOrderUpdate.bind(this)
    })
  }

  initializeState() {
    this.oldSortedActivityIdentifiers = this.sortedActivityIdentifiers
    this.updateState()
  }

  initializeChangeObserver() {
    this.changeObserver = new MutationObserver((mutations => {
      this.dragHandler.isDragging() || this.postOrderUpdate()
    }).bind(this))
    this.changeObserver.observe(this.element, {
      childList: true,
      characterData: true
    })
  }

  postOrderUpdate() {
    if (this.sortedListHasChanged) {
      App.Helpers.ajaxRequest({
        url: this.orderUpdateURL,
        method: "POST",
        data: this.orderData
      })
      this.updateState()
    }
  }

  appendNewActivity(event) {
    const { html } = event.detail
    if (this.isRelevantActivity(event)) {
      const newEl = App.Helpers.getElementFromString(html)
      this.addNewActivity(newEl)
    }
  }

  replaceActivity(event) {
    const { html, rowID, retry } = event.detail
    let row
    if (this.isRelevantActivity(event)) {
      if (row = this.getRowByID(rowID)) {
        App.Helpers.replaceElement(row, html)
      } else if (!retry || retry < 3) {
        event.detail.retry = retry ? retry + 1 : 1
        setTimeout((() => this.replaceActivity(event)).bind(this), 500)
      } else {
        this.appendNewActivity(event)
      }
    } else {
      this.removeActivity(event)
    }
  }

  removeActivity(event) {
    const { rowID } = event.detail
    const row = this.getRowByID(rowID)
    if (this.isRelevantActivity(event) && row) {
      row.remove()
    }
  }

  removeSchedulableMaybe(event) {
    const { schedulableID } = event.detail
    const row = this.getRowByID(`my-via--day-activity--event-${schedulableID}`)
    if (row) {
      row.remove()
    }
  }

  updateState() {
    this.oldSortedActivityIdentifiers = this.sortedActivityIdentifiers
    dispatchCustomEvent(this.stateEventName, this.element, { date: this.date })
  }

  getRowByID(rowID) {
    return this.element.querySelector(`#${rowID}`)
  }

  isRelevantActivity(event) {
    const { userID, date } = event.detail
    return userID == this.userID && date == this.date
  }

  addNewActivity(activity) {
    const index = this.indexForActivity(activity)
    const allItems = [...this.allItemsExceptDayReview]
    const newAllItems = allItems.slice(0, index).concat([activity]).concat(allItems.slice(index))
    const allRows = this.hasDayReviewTarget ? newAllItems.concat([this.dayReviewTarget]) : newAllItems
    this.element.innerHTML = allRows.map(item => item.outerHTML).join("")
  }

  indexForActivity(activity) {
    if (this.isEvent(activity)) {
      return this.indexForEvent(activity)
    }
    return this.allItems.length
  }

  indexForEvent(event) {
    let res = 0
    this.allItems.forEach((item, index) => {
      if (this.isEvent(item) && event.dataset.orderKey > item.dataset.orderKey) {
        res = index + 1
      }
    })
    return res
  }

  isEvent(activity) {
    return activity.dataset.type == "event"
  }

  //
  // GETTERS AND SETTERS
  //

  get allItems() {
    return this.element.querySelectorAll("tr")
  }

  get allItemsExceptDayReview() {
    if (!this.hasDayReviewTarget) {
      return this.allItems
    }
    return [...this.allItems].filter(item => item !== this.dayReviewTarget)
  }

  get userID() {
    return this.data.get("user-id")
  }

  get date() {
    return this.data.get("date")
  }

  get rows() {
    return [...(this.eventTargets || []), ...(this.milestoneTargets || []), ...(this.taskTargets || [])]
  }

  get isEmpty() {
    return this.rows.length === 0
  }

  get stateEventName() {
    if (this.isEmpty) {
      return "digest-day:empty"
    }
    return "digest-day:populated"
  }

  get orderUpdateURL() {
    return this.data.get("order-update-url")
  }

  get orderData() {
    return {
      date: this.date,
      user_day: {
        sorted_activity_identifiers: this.sortedActivityIdentifiers
      }
    }
  }

  get sortedActivityIdentifiers() {
    return [...this.allItemsExceptDayReview].map(item => `${item.dataset.type}-${item.dataset.activityId}`)
  }

  get sortedListHasChanged() {
    const res = !App.Helpers.arraysAreEqual(this.oldSortedActivityIdentifiers, this.sortedActivityIdentifiers)
    return res
  }

  get sortableActvityTypes() {
    return ["task", "event", "milestone"]
  }
}



// WEBPACK FOOTER //
// ./app/components/my_via/assets/javascript/my-via-day-activities-controller.js